import { Component, OnInit, inject, input, signal } from '@angular/core';
import { TenantRepository } from '@repository/tenant/tenant.repository';
import { Constants } from '@utils/Constants';
import { SkeletonComponent } from '@ui/skeleton/skeleton.component';

@Component({
  selector: 'app-tenant-logo',
  templateUrl: './tenant-logo.component.html',
  styleUrl: './tenant-logo.component.scss',
  imports: [SkeletonComponent],
})
export class TenantLogoComponent implements OnInit {
  public readonly useMasterLogo = input<boolean>(false);
  public readonly tenantLogoSrc = signal<string | undefined>(undefined);
  private readonly tenantRepository = inject(TenantRepository);

  public ngOnInit(): void {
    if (this.useMasterLogo()) {
      this.tenantLogoSrc.set(Constants.MASTER_TENANT_LOGO);
      return;
    }

    this.tenantRepository.getTenantLogo().subscribe((tenantLogo) => {
      this.tenantLogoSrc.set(tenantLogo === Constants.NO_IMAGE ? Constants.MASTER_TENANT_LOGO : tenantLogo);
    });
  }
}
